import { useButtonClick } from '@/hooks/useButtonClick'
import { getSlugTranslation } from '@/locale/utils'
import { ACTION_TYPE } from '@/types/action'
import { BUTTON_ACTION_TYPE } from '@/types/components'

export const TakeAgain = () => {
  const { handleButtonClick } = useButtonClick()

  const handleReset = () => {
    handleButtonClick({
      type: BUTTON_ACTION_TYPE.RELOAD_PAGE,
      previousActions: [
        {
          action: ACTION_TYPE.RESET_TRACES
        }
      ]
    })
  }

  return (
    <div className="sticky bottom-0 flex w-full flex-col gap-6 rounded-t-2xl bg-white p-6 shadow-strong" data-testid="take-again-container">
      <button
        className="text-sm font-bold uppercase text-primary"
        onClick={() => {
          handleReset()
        }}
        data-testid="take-again-button"
      >
        {getSlugTranslation('answer.reset')}
      </button>
    </div>
  )
}
